<template>
  <div style="padding-bottom: 40px" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>
    <div class="cep61_top">
      <h1>{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <a @click="reset" v-if="data.past_days>=30">重新测试</a>
      <a v-else style="background-color:#ccc">{{30-data.past_days}} 天后可重测</a>
    </div>
    <div class="cep61_main">
      <h1><img src="@a/cep61_1.png">职业代码<img src="@a/cep61_2.png"></h1>
      <h2 class="cep61_mh2">您的霍兰德代码</h2>
      <div class="cep61_list clearfix">
        <ul>
          <li v-for="(item,index) in data.self_result_top" :key="index">
            <h2>{{item.division}}</h2>
            <h3>
              <span v-for="(itm,idx) in item.keywords" :key="idx">{{itm}}</span>
            </h3>
          </li>
        </ul>
      </div>
      <h2 class="cep61_mh2">您的得分图</h2>
      <div class="dimension_bg">
        <div id="dimension" class="dimension"></div>
      </div>
      <div class="cep61_list1 clearfix">
        <ul>
          <li v-for="(item,index) in data.self_result_desc" :key="index">
            <h2>{{item.division}}</h2>
            <h3>{{item.avg}}</h3>
          </li>
        </ul>
      </div>
    </div>
    <div class="cep61_main">
      <h1><img src="@a/cep61_1.png">定位报告<img src="@a/cep61_2.png"></h1>
      <p class="cep61_mp">根据您的霍兰德代码推荐以下职业。为了呈现更多可能性，同时列出了与你的霍兰德代码相关代码所对应的职业，供你参考。</p>
      <div class="cep61_list2">
        <ul>
          <li v-for="(item,index) in data.recommend" :key="index" v-if="item.recommendation!=''">
            <h2>{{item.report_key}}</h2>
            <h3>{{item.recommendation}}</h3>
          </li>
        </ul>
      </div>
    </div>
    <div class="cep61_main">
      <h1><img src="@a/cep61_1.png">发展倾向<img src="@a/cep61_2.png"></h1>
      <h2 class="cep61_mh2">天生兴趣</h2>
      <div class="cep61_list3">
        <ul>
          <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
            <img src="@a/dian.png" alt="" />
            <div class="cep61_lr">{{item.interest}}</div>
          </li>
        </ul>
      </div>
      <h2 class="cep61_mh2">职业潜能 </h2>
      <h3 class="cep61_mh3">适合的工作类型： </h3>
      <div class="cep61_list3">
        <ul>
          <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
            <img src="@a/dian.png" alt="" />
            <div class="cep61_lr">{{item.potential}}</div>
          </li>
        </ul>
      </div>
      <h3 class="cep61_mh3">职业示例： </h3>
      <div class="cep61_list2 cep61_list4">
        <ul>
          <li v-for="(item,index) in data.example" :key="index" class="clearfix">
            <h2>{{item.title}}</h2>
            <h3 v-html="item.text"></h3>
          </li>
        </ul>
      </div>
      <div class="cep61_bt">
        <h2></h2>
        <div class="cep61_btv">
          列出的职业你都不感兴趣？
          <br/>你可以不拘泥于推荐岗位，探索更多的可能职业：测评结果中的代码是最接近你职业兴趣的代码，但还存在其他的排列组合方式；同时，根据代码推荐的只是常见职业，还有其他职业也满足该职业兴趣。你可以参照岗位示例，分析其他可能满足你的职业兴趣的职业，打开可能性。
        </div>
      </div>
      <h3 class="cep61_mh3">避免领域： </h3>
      <h4 class="cep61_mh4">{{data.avoid}}</h4>
      <h2 class="cep61_mh2">发挥与创造</h2>
      <h4 class="cep61_mh4">无论具体从事哪项工作，您都可以遵循自己的内心，将自己</h4>
      <div class="cep61_list5">
        <ul>
          <li v-for="(item,index) in data.self_result_top" :key="index" class="clearfix">
            {{item.creation}}
          </li>
        </ul>
      </div>
      <h4 class="cep61_mh4">转化成工作成功的动力来源。</h4>
      <div class="cep61_bt">
        <h2></h2>
        <div class="cep61_btv">
          感觉当前职业不能发挥你的职业兴趣？
          <br/> 你可以挖掘当前职业的更多意义：
          <br/> （1）职业最优解并非固定。职业发展是不断变化的动态过程，会随着阅历、知识、环境等发生改变，因此，职业最优解并非固定。
          <br/> （2）平衡好最优解与满意解。了解自己职业兴趣，是为了找到最适合自己的职业，但现实中因为资源和条件的限制，可能此时从事的职业并非是最符合自己兴趣的，但很可能是当前可获得的满意解。
          <br/> （3）赋予职业以意义。你在职业生涯选择中是有主观能动性的，你完全可以在当前工作界定新的内涵、创造新的意义。 </div>
      </div>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ceping61_report,
  ceping61_reset
} from "@/api/measurement";
import {
  shareCon
} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import {
  Dialog
} from 'vant';
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        fl_group: [],
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        }
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping61_reset()
            .then((data) => {
              this.$router.push("/ceping61")
            })
        }).catch(() => {
          // on cancel
        });
      },
      dimension_chart() {
        let dimension = echarts.init(document.getElementById('dimension'));
        let dimension_indicator = [];
        let dimension_value = [];
        let arry = [];
        arry.push(this.data.self_result[0]);
        arry.push(this.data.self_result[5]);
        arry.push(this.data.self_result[4]);
        arry.push(this.data.self_result[3]);
        arry.push(this.data.self_result[2]);
        arry.push(this.data.self_result[1]);

        for (let attr in arry) {
          dimension_indicator.push({
            text: arry[attr].division + '. ' + arry[attr].type,
            max: 10
          });
          dimension_value.push(arry[attr].avg);
        }
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          radar: [{
            indicator: dimension_indicator,
            center: ['50%', '62%'],
            name: {
              textStyle: {
                color: '#E8576F',
                padding: [
                  0, // 上
                  0, // 右
                  20, // 下
                  0, // 左
                ]
              }
            },
            startAngle: 120,
            radius: 80
          }],

          series: [{
            type: 'radar',
            areaStyle: {
              normal: { //区域填充样式
                color: '#E8576F',
                opacity: '0.6'
              }
            },
            itemStyle: { //折线拐点标志的样式
              color: '#E8576F',
            },
            data: [{
              name: '得分',
              value: dimension_value,
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  }
                }
              }
            }]
          }]
        };

        // 为echarts对象加载数据
        dimension.setOption(option);
      },
      pullData() {
        ceping61_report()
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              this.qrcode = data.qrcode;
              if (this.data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping61", this, this.type_obj);
              setTimeout(() => {
                this.dimension_chart();
              }, 1000);
            } else {
              // 已经测评完成
              this.$router.push('/ceping61')
            }

          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.dimension_bg {
  background: url(../../../assets/dema_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 630px;
}

.dimension {
  margin: 0 auto;
  height: 510px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.cep61_top {
  width: 100%;
  background: url(../../../assets/cep61_t.png) no-repeat top center;
  background-size: cover;
  height: 470px;
  padding: 0 60px;
  padding-top: 72px;
  color: #333;
  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  h2 {
    font-size: 26px;
    margin-top: 30px;
  }
  h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: rgba(232, 87, 111, 1);
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}

.cep61_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 60px;
  padding: 70px 30px;
  h1 {
    font-size: 46px;
    color: #E8576F;
    text-align: center;
    font-weight: bold;
    img {
      width: 44px;
      margin: 0 50px;
    }
  }
  p.cep61_mp {
    font-size: 32px;
    line-height: 64px;
    color: #333;
    text-align: justify;
    margin-top: 70px;
    font-weight: bold;
  }
  h2.cep61_mh2 {
    font-size: 32px;
    color: #333;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h3.cep61_mh3 {
    font-size: 28px;
    color: #E8576F;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h4.cep61_mh4 {
    font-size: 26px;
    color: #333;
    text-align: justify;
    margin-top: 40px;
    line-height: 50px;
  }
  .cep61_list {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 30px;
      width: 190px;
      text-align: center;
      h2 {
        height: 118px;
        line-height: 118px;
        background: rgba(232, 87, 111, 1);
        border-radius: 8px 8px 0px 0px;
        color: #fff;
        font-size: 60px;
      }
      h3 {
        height: 118px;
        line-height: 44px;
        background: #F0F0F0;
        color: #333;
        font-size: 28px;
        padding-top: 20px;
        span {
          display: block;
        }
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list1 {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 2px;
      width: 103px;
      text-align: center;
      h2 {
        height: 60px;
        line-height: 60px;
        background: rgba(232, 87, 111, 1);
        color: #fff;
        font-size: 32px;
      }
      h3 {
        height: 60px;
        line-height: 60px;
        background: #F0F0F0;
        color: #333;
        font-size: 26px;
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list2 {
    ul li {
      margin-top: 60px;
      h2 {
        color: #E8576F;
        font-size: 28px;
      }
      h3 {
        color: #333;
        margin-top: 40px;
        line-height: 50px;
        text-align: justify;
        font-size: 28px;
      }
    }
  }
  .cep61_list3 {
    ul li {
      margin-top: 60px;
      position: relative;
      img {
        width: 11px;
        height: 11px;
        position: absolute;
        top: 20px;
        left: 0;
      }
      .cep61_lr {
        width: 596px;
        float: right;
        text-align: justify;
        color: #333;
        font-size: 26px;
        line-height: 50px;
      }
    }
  }
  .cep61_list4 {
    ul li {
      h2 {
        color: #333;
        font-size: 26px;
        font-weight: bold;
      }
      h3 {
        font-size: 26px;
      }
    }
  }
  .cep61_bt {
    margin-top: 65px;
    h2 {
      width: 630px;
      height: 30px;
      background: rgba(232, 87, 111, 1);
      border-radius: 15px 15px 0px 0px;
    }
    .cep61_btv {
      padding: 26px;
      line-height: 50px;
      font-size: 26px;
      color: #333;
      text-align: justify;
      background-color: #FEF6F8;
    }
  }
  .cep61_list5 {
    ul li {
      margin: 0 auto;
      margin-top: 60px;
      width: 440px;
      border-bottom: 2px solid #E8576F;
      padding-bottom: 14px;
      text-align: center;
      font-size: 26px;
      color: #333;
      font-weight: bold;
    }
  }
}
</style>
